import React, { useState, useEffect } from 'react';
import BasePage from '../components/BasePage';
import Fields from '../components/Fields';
import Image from '../components/Image';
import DocumentButton from '../components/Buttons/DocumentButton';
import { format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { MessageCircleQuestion, BookA, Wrench } from 'lucide-react';
import Struct from '../components/Struct';



const Infos = (props) => {


    const content = (data) => {
        console.log("Données récupérées: " . data);

        if (!data) {
            return false;
        }

        return (
            <div id="infos" className="flex flex-col h-full">
                {data ? (
                    <>
                        <h1 className="page-title">{props.title}</h1>
                        <div className="grid grid-cols-2 grid-rows-2 gap-4 p-4 mb-10">
                            <div className="mt-8 ">
                                <Link to="https://wiki.meosis.fr/" target="_blank" className="bg-mlime text-lg px-6 py-4 rounded-3xl w-full max-w-lg flex items-center justify-center text-white font-bold block text-center m-auto">
                                    Wiki Meosis
                                    <BookA className="ml-3" />
                                </Link>
                            </div>

                            <div className="mt-8 ">
                                <Link to="https://www.meosis.fr/faq.html" target="_blank" className="bg-mlime text-lg px-6 py-4 rounded-3xl w-full max-w-lg flex items-center justify-center text-white font-bold block text-center m-auto">
                                    FAQ
                                    <MessageCircleQuestion className="ml-3" />
                                </Link>
                            </div>

                            <div className="mt-8 ">
                                <Link to={`https://${data.ndd}`} target="_blank" className="bg-mlime text-lg px-6 py-4 rounded-3xl w-full max-w-lg flex items-center justify-center text-white font-bold block text-center m-auto">
                                    Mon site
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right" className="ml-3 text-2xl -rotate-45" />
                                </Link>
                            </div>

                            <div className="mt-8 ">
                                <Link to={`https://www.meosis.fr/`} target="_blank" className="bg-mlime text-lg px-6 py-4 rounded-3xl w-full max-w-lg flex items-center justify-center text-white font-bold block text-center m-auto">
                                    Meosis
                                    <FontAwesomeIcon icon="fa-solid fa-rocket" className="ml-3 text-2xl"/>
                                </Link>
                            </div>

                        </div>
                    </>
                ) : (
                    // Sinon, affiche un message de chargement ou d'erreur
                    <p>Chargement en cours...</p>
                )}
            </div>

        )
    };
    return <BasePage content={content} title={props.title ?? null} />;
};

export default Infos;
